import { useAtom } from '@reatom/npm-react'

import { FlashTextContent } from '@root/shared/ui-kit'

import { isFlashTemporalDistinctEnabledAtom } from './atoms/flash-temporal-distinct'

import type { FlashTextContentProps } from '@root/shared/ui-kit'

type Props = Omit<FlashTextContentProps, 'disabled'>

export const FlashTextContentDistinct = ({ ...props }: Props) => {
  const [isEnabled] = useAtom(isFlashTemporalDistinctEnabledAtom)

  return <FlashTextContent disabled={!isEnabled} {...props} />
}
